import React, { useState } from "react";
import StarRateIcon from "@mui/icons-material/StarRate";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import House from "../../Assets/images/houso.png";
import AllApartment from "./AllApartment";

function RentalListCom({ rental }) {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <AllApartment
        open={open}
        handleClose={handleClose}
        apartmentId={rental?.id}
        parentData={rental}
      />
      <div className="flex bg-white shadow-sm p-4 mb-4 rounded-xl border border-gray-100 items-center gap-4">
        <img
          src={rental?.apartmentImages?.[0]?.imageUrl || House}
          alt=""
          className="w-[120px] h-[120px] rounded-lg object-cover"
        />
        <div className="flex flex-col w-full">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-[#1E222B] font-[600] text-[18px]">
              {rental?.title || ""}
            </h3>
            {/* <p className="text-back-color2 font-[400] text-[14px] flex items-center gap-1">
              <StarRateIcon className="text-[#A3D133]" fontSize="small" />
              4.0 (26)
            </p> */}
          </div>
          <div className="flex items-center gap-4 mb-5">
            <p className="text-[#1E222B] text-[14px]">ID- #{rental?.id}</p>
            <p className="text-[#1E222B] text-[14px] flex items-center gap-1">
              <FmdGoodOutlinedIcon
                fontSize="small"
                className="text-[#808285]"
              />
              {rental?.locality} • {rental?.street}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="bg-[#F8FAFC] py-3 px-4 rounded-md">
              <p className="text-[#1E222B] font-[600] text-[14px]">
                {rental?.numberOfApartmentAvailable || 0} Apartment classes
              </p>
            </div>
            <button
              onClick={handleOpen}
              className="bg-[#00BC67] hover:bg-[#00a85a] transition-colors text-white font-[500] text-[14px] py-3 px-6 rounded-md"
            >
              View Apartments
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default RentalListCom;
